<template>
  <div id="place-order">
    <drag-float-button :total-count="totalCount"></drag-float-button>
    <div id="place-order-header">
      <div v-if="addAddress" class="place-header-detail">
        无默认收货地址
        <span class="add-address" @click="modifyAddress">添加收货地址</span>
      </div>
      <div v-else class="place-header-detail" @click="modifyAddress">
        <div class="detail-info">
          <div class="username">
            <span>{{ username }}</span> <span style="margin-left: 40px">{{ tel }}</span>
          </div>

          <div class="address">
            {{ address }}
          </div>
        </div>

        <img class="icon" src="../../assets/common_next.png" alt=""
             style="background: #faf2ed">

        <div style="clear:both;"></div>
      </div>
    </div>

    <div id="place-order-line">
    </div>

    <div id="place-order-body">
      <div class="place-order-line"></div>
      <div class="place-order-body-yk" v-for="(item,index) in goodsList" :key="item.id">
        <!--<img v-if="yklBase64ImageUrl" class="place-yk-img" src="../../assets/order_detail_yakult.png" alt="">-->
        <img class="place-yk-img" :src="item.imageUrl" alt="">
        <div class="place-yk-explain">
          <div class="title">
            {{ item.name }}
          </div>

          <div class="rule">
            <span>规格：  </span><span style="color: #757575;">{{ item.spec }}</span>
          </div>

          <div class="price">
            <span>RMB:   </span><span style="color: #ed3f14">￥{{ item.price }}</span>
          </div>

          <div class="explain-number">
            <div class="add" :class="{ disabled: isDisabled(item) }" @click="isDisabled(item) ? null : ykReduce(item,index)">
              -
            </div>
            <div class="number" :class="{ disabled: isDisabled(item) }">
              {{ item.ykNumber }}
            </div>
            <div class="add" :class="{ disabled: isDisabled(item) }" @click="isDisabled(item) ? null : ykAdd(item,index)">
              +
            </div>
          </div>

          <!-- <div v-if="isDisabled(item)" class="tip">
            <span>到货时间不同，不可同时下单</span>
          </div> -->
        </div>
      </div>

      <div style="clear:both;"></div>

      <div class="place-yk-remark">
                <textarea v-model="remark" class="place-remark-input"
                          placeholder="备注：可填写期望配送时间（如10：00-11：00）等信息。如单项产品订购超过20排时，也请在备注内说明。"></textarea>
            </div>
            <!-- 隐藏印花活动兑换窗口，下次开启活动时打开注释 -->
            <!-- <div class="place-yk-remark1">
            <div class="place-remark-input1">使用活动码完成订单额外领取印花</div>
            <input
                class="clickable-line custom-placeholder"
                v-model="code"
                :placeholder="showPlaceholder ? '请输入活力印花券码,完成订单领取印花' : ''"
                @focus="onFocus"
                @blur="onBlur"
            />
          </div>-->
        </div>

    <div class="place-order-box"></div>

    <div id="place-order-footer">
      <div class="place-footer-price">
        <div>结算金额： <span class="price-number">￥{{ ykTotalPrice }}</span>
        </div>
        <div>支付方式：与益力多姐姐现金交易</div>
      </div>
      <div class="place-submit-order" @click="orderTip">
        提交订单
      </div>
    </div>

    <base-dialog v-if="messageVisible" :title="title" width="80%" @close="close">
      <p>{{ message }}</p>
    </base-dialog>

    <!--下单提示-->
    <base-dialog v-if="orderVisible" :title="title" display="none" width="80%" @close="close">
      <p class="tip">用户系统无支付功能，费用直接交给益力多姐姐</p>
      <template v-if="canParticipate">
        <p v-if="needPurchaseQuantity - totalCount > 0" class="tip">本单再购买{{ needPurchaseQuantity - totalCount }}支即可参与先到先得活动</p>
      </template>
      <p>是否确认提交订单</p>
      <p class="tip" v-if="stampList.length > 0 && selectedStampCount <= 0">您有兑换券可使用，可与本单一起配送</p>
      <p class="tip" v-if="stampList.length > 0 && selectedStampCount > 0">
        您已选择 <span style="color: #15D2AC;">{{selectedStampNamesText}}</span>，请确认
      </p>
      <p class="tip" v-if="stampList.length <= 0">您无兑换券可使用</p>
      <button class="tip-stamp" @click="useStamp" :disabled="stampList.length <= 0">使用兑换券<span v-if="selectedStampCount > 0">({{ selectedStampCount }})</span></button>
      <button class="tip-cancel" @click="close">取消</button>
      <button class="tip-ok" @click="submitOrder" :disabled="btnDisable">确认</button>
    </base-dialog>

    <!--兑换卷弹窗-->
    <base-dialog v-if="stampVisible" title="请勾选需要兑换的礼品" width="80%" display="none" @close="closeStampDialog">
      <p class="message">请勾选需要兑换的礼品</p>
      <div class="stamp-list">
        <!--父选项-->
        <div class="stamp-item" v-for="(item, index) in stampList" :key="item.id">
          <div class="stamp-parent" :class="{ 'has-child': item.child && item.child.length > 0 }" @click="selectStamp(item, index)">
            <!--展开/收起箭头指示-->
            <div class="expand-icon" v-if="item.child && item.child.length > 0">
              <span class="arrow" :class="{ 'expanded': item.expanded }">▼</span>
            </div>
            <div class="stamp-info">
              <div class="stamp-name">{{ item.type }}：{{ item.name }}</div>
              <div class="stamp-time">{{ item.time }}</div>
              <div class="stamp-hint" v-if="item.child && item.child.length > 0 && item.expanded">
                请选择您要兑换的商品
              </div>
            </div>
            <!--有子选项时父选项不显示复选框-->
            <div class="stamp-checkbox" v-if="!item.child || item.child.length === 0">
              <div class="checkbox-wrapper" v-if="item.selected">
                <img src="../../assets/check_box_24px_rounded.png" alt="" style="width: 20px; height: 20px;">
              </div>
              <div class="checkbox-border" v-else></div>
            </div>
            <!--有子选项时显示提示文字-->
              <div class="stamp-checkbox" v-if="item.child && item.child.length > 0">
                <div class="checkbox-wrapper" v-if="item.expanded">
                  <img src="../../assets/check_box_24px_rounded.png" alt="" style="width: 20px; height: 20px;">
                </div>
                <div class="checkbox-border" v-else></div>
              </div>
<!--            <div class="child-hint" v-if="item.child && item.child.length > 0">-->
<!--              {{ item.selectedChildCount }}/{{ item.child.length }}已选-->
<!--            </div>-->
          </div>

          <!--子选项列表 - 展开时显示-->
          <div class="stamp-child-list" v-if="item.child && item.child.length > 0 && item.expanded">
            <div class="stamp-child-item" v-for="(child, childIdx) in item.child" :key="child.id" @click="selectChildStamp(index, childIdx)">
              <div class="child-info">
                <div class="child-name">{{ child.name }}</div>
              </div>
              <div class="child-checkbox">
                <img v-if="child.selected" src="../../assets/check_box_rounded.png" alt="" style="width: 18px; height: 18px; border-radius: 50%;">
                <div class="checkbox-border-small" v-else></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="stamp-buttons">
        <button class="stamp-cancel-btn" @click="closeStampDialog">取消</button>
        <button class="stamp-confirm-btn" @click="confirmStamp">确认</button>
      </div>
    </base-dialog>

    <!--非配送日提示-->
    <base-dialog v-if="deliverVisible" :title="title" width="80%" @close="close">
      <p class="tip" style="font-size: 1.3rem">温馨提示</p>
      <p class="tip">今天是非配送时间，下单后预计配送时间为{{ deliverMessage }}</p>
    </base-dialog>


    <!--活动码弹窗-->
    <base-dialog v-if="checkStampCode" :title="title" width="80%" @close="close">
      <p class="tip" style="font-size: 1.3rem">温馨提示</p>
      <p class="tip">您提供的活动码无效，请重新输入活动码或不输入活动码提交订单!</p>
    </base-dialog>

    <!-- <base-dialog v-if="newProduct" width="80%" @close="close">
      因20支是预售，预计下单后3-4天才进行配送，所以请确认需求后再下单。
    </base-dialog> -->

    <div class="toast" v-show="toastShow">
      {{ toastText }}
    </div>

  </div>
</template>

<script>
import {GoodsList} from "@/api/Goods";
import {BASE_URL, LIMIT} from "@/config/app";
import {numFilter, starPhone} from "@/unitls";
import {AddressDefault} from "@/api/Address";
import BaseDialog from "@/components/BaseDialog";
import {OrderDeliver, OrderSubmit} from "@/api/Orders";
import {checkStamp, getStampMaxNum} from "@/api/Stamp";
import {CheckPresale} from "../../api/Orders";
// import DragFloatButton from "@/components/DragFloatButton";
import {CheckActivityOrderSubmit} from "../../api/Activity";
import {voucherOrderList} from "../../api/StampShop";


export default {
  name: "PlaceOrder",
  components: {BaseDialog},
  data() {
    return {
      showPlaceholder: true,
      type: this.$route.query.type,

      username: '',
      tel: '',
      address: '',
      addressId: 0,

      goodsList: [],
      ykTotalNumber: 0,
      ykTotalPrice: 0,
      remark: '',

      code: '',


      toastShow: false,
      toastText: '',

      title: '提示',
      messageVisible: false,
      message: "",
      isShow: false,

      isQingti20Selected: false,
      newProduct: false,

      orderVisible: false,

      checkStampCode: false,

      deliverVisible: false,
      deliverMessage: '',

      addAddress: false,

      btnDisable: false,

      stampMaxNum: 999,

      buttonStatus: 0,
      grapePresale: true,
      totalCount: 0,
      canParticipate: false,
      needPurchaseQuantity: 999,

      stampVisible: false,
      stampList: [],
      selectedStamps: [],
      selectedStampCount: 0,
      selectedStampNamesText: ''
    }
  },

  computed: {
    isDisabled() {
      return (item) => {
        return this.buttonStatus !== 0 &&
            ((this.buttonStatus === 1 && ((item.id === this.$GOODS.YAKULT_TEN_DT_ID && this.grapePresale))) ||
                (this.buttonStatus === 3 && item.id !== this.$GOODS.YAKULT_TEN_DT_ID));
      };
    }
  },
  mounted() {
    this.requestPresaleStatus();
    this.requestStampList();
    // this.requestStampMaxNum();
    this.requestGoodsList();
    if (this.$route.query.type === 1) {
      this.ykNumber++;
      this.ykTotalPrice = this.ykPrice
    } else if (this.$route.query.type === 2) {
      this.ykLowSugarNumber++;
      this.ykTotalPrice = this.ykLowSugarPrice
    } else if (this.$route.query.type === 3) {
      this.ykNoSugarNumber++;
      this.ykTotalPrice = this.ykNoSugarPrice
    }

    let addId = localStorage.getItem('addressId');
    if (addId == null || addId === '') {
      //获取用户默认收货地址
      this.requestMemberDefaultAddress();
    } else {
      this.addressId = localStorage.getItem('addressId');
      this.username = localStorage.getItem('username');
      this.address = localStorage.getItem('userAddress');
      this.tel = localStorage.getItem('userPhone');
    }

    this.requestOrderDeliver();

    let ykTotalPrice = localStorage.getItem('ykTotalPrice');
    if (ykTotalPrice !== null && ykTotalPrice !== '') {
      this.ykTotalPrice = ykTotalPrice;
    }

    let remark = localStorage.getItem('remark');
    if (remark !== null && remark !== '') {
      this.remark = remark;
    }
  },

  beforeDestroy() {
  },

  methods: {
    onFocus() {
      this.showPlaceholder = false;
    },
    onBlur() {
      if (this.code === '') {
        this.showPlaceholder = true;
      }
    },
    cancel() {
      this.deliverVisible = false;
      this.$router.go(-1);
    },

    close() {
      this.messageVisible = false;
      this.orderVisible = false;
      this.newProduct = false;
      this.deliverVisible = false;
      this.checkStampCode = false;
      this.stampVisible = false;
      this.$emit('close');
    },

    useStamp() {
      this.stampVisible = true;
      this.requestStampList();
    },

    /**
     * 根据已选中的数据还原列表的选中状态
     * 用于再次打开弹窗时的状态回显
     */
    restoreSelectedState(stampList) {
      const selected = this.selectedStamps;
      if (!selected || selected.length === 0) return stampList;

      return stampList.map(stamp => {
        let updatedStamp = { ...stamp };

        // 还原无子选项的独立项
        if (!stamp.child || stamp.child.length === 0) {
          const hasSelected = selected.some(s => s.parentId === stamp.id && s.childId === null);
          updatedStamp.selected = hasSelected;
        } else {
          // 还原有子选项的子项选中状态
          updatedStamp.child = stamp.child.map(child => {
            const hasSelected = selected.some(s =>
              s.parentId === stamp.id && s.childId === child.id
            );
            return { ...child, selected: hasSelected };
          });
          // 默认展开有选中子项的父项
          const hasAnySelected = updatedStamp.child.some(c => c.selected);
          if (hasAnySelected) {
            updatedStamp.expanded = true;
          }
        }
        return updatedStamp;
      });
    },

    closeStampDialog() {
      this.stampVisible = false;
    },

    /**
     * 父选项点击事件：处理展开/收起和选中逻辑
     * 有子选项时只做展开/收起，父选项本身不可选中
     * 无子选项时直接选中该选项
     */
    selectStamp(item, index) {
      const hasChild = item.child && item.child.length > 0;

      const updatedList = this.stampList.map((stamp, idx) => {
        if (idx === index) {
          if (hasChild) {
            // 有子选项时，切换展开状态
            return { ...stamp, expanded: !stamp.expanded };
          } else {
            // 无子选项时，切换选中状态
            return { ...stamp, selected: !stamp.selected };
          }
        }
        return stamp;
      });

      // 更新已选子选项数量统计
      const finalList = this.updateSelectedCount(updatedList);

      this.stampList = finalList;
    },

    /**
     * 计算并更新每个父项下已选中的子选项数量
     */
    updateSelectedCount(stampList) {
      return stampList.map(stamp => {
        if (stamp.child && stamp.child.length > 0) {
          const selectedCount = stamp.child.filter(c => c.selected).length;
          return { ...stamp, selectedChildCount: selectedCount };
        }
        return stamp;
      });
    },

    /**
     * 子选项点击事件：选中/取消选中子选项（单选逻辑）
     * 同一父项下的子选项只能选中一个，互斥选择
     */
    selectChildStamp(parentIndex, childIndex) {
      const isCurrentSelected = this.stampList[parentIndex].child[childIndex].selected;

      const updatedList = this.stampList.map((stamp, pIdx) => {
        if (pIdx === parentIndex) {
          const updatedChild = stamp.child.map((child, cIdx) => {
            if (cIdx === childIndex) {
              // 点击当前项：切换选中/取消
              return { ...child, selected: !child.selected };
            } else if (!isCurrentSelected) {
              // 如果当前点击的是未选中项，选中它，同时同组其他全部取消
              return { ...child, selected: false };
            }
            // 当前点击的是已选中项，只是取消它，其他保持不变
            return child;
          });
          return { ...stamp, child: updatedChild };
        }
        return stamp;
      });

      // 更新已选子选项数量统计
      const finalList = this.updateSelectedCount(updatedList);

      this.stampList = finalList;
    },

    /**
     * 确认选择：收集所有选中的子选项和独立项
     * 必须选择至少一项才能确认
     * 输出格式：[{parentId: 'xxx', childId: 'yyy'}, ...]
     */
    confirmStamp() {
      const selectedResult = [];
      const selectedNames = [];

      this.stampList.forEach(stamp => {
        const hasChild = stamp.child && stamp.child.length > 0;

        if (hasChild) {
          // 有子选项的情况：只收集选中的子选项
          stamp.child.forEach(child => {
            if (child.selected) {
              selectedResult.push({
                parentId: stamp.id,
                childId: child.id
              });
              selectedNames.push(child.name);
            }
          });
        } else {
          // 无子选项的独立项
          if (stamp.selected) {
            selectedResult.push({
              parentId: stamp.id,
              childId: null
            });
            selectedNames.push(stamp.name);
          }
        }
      });

      // 必填校验：必须选择至少一项礼品
      if (selectedResult.length > 3) {
        this.toast('选择的礼品不能超过3个');
        return;
      }

      // 输出选中的数据到控制台，便于后续接口调用
      console.log('已选中的礼品数据:', selectedResult);

      console.log('已选中的礼品名称:', selectedNames);
      const selectedStampNamesText = selectedNames.join('、');

      this.stampVisible = false;
      this.selectedStamps = selectedResult;
      this.selectedStampCount = selectedResult.length;
      this.selectedStampNamesText = selectedStampNamesText;

      this.toast('使用成功');
    },

    requestStampList() {
      voucherOrderList()
        .then((response) => {
          if (response.code === this.$API_CODE.OK) {
            let list = [];
            response.data.forEach(item => {
              if (item.stampShopAwardId) {
                const exchangePrizeList = item.exchangePrizeList || [];
                let childList = [];

                if (exchangePrizeList.length > 1) {
                  childList = exchangePrizeList.map(prize => ({
                    id: prize.id,
                    name: prize.productname,
                    selected: false
                  }));
                }

                list.push({
                  id: item.id,
                  type: item.activityName,
                  name: exchangePrizeList.length > 1 ? item.awardName : `${item.awardName || ''}(${item.duiName || ''})`,
                  time: this.formatTime(item.exchangeTime),
                  selected: false,
                  expanded: false,
                  selectedChildCount: 0,
                  child: childList
                });
              } else {
                list.push({
                  id: item.id,
                  type: item.activityName,
                  name: item.duiName || '',
                  time: this.formatTime(item.exchangeTime),
                  selected: false,
                  expanded: false,
                  selectedChildCount: 0,
                  child: []
                });
              }
            });
            // 还原之前选中的状态（回显）
            list = this.restoreSelectedState(list);
            // 初始化已选子选项数量统计
            list = this.updateSelectedCount(list);
            this.stampList = list;
          }
        })
        .catch((error) => {
          console.error('Error fetching stamp list:', error);
        });
    },

    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },

    toast(e) {
      let _that = this;
      this.toastText = e;
      this.toastShow = true;
      setTimeout(function () {
        _that.toastShow = false;
      }, 1500)
    },

    // 获取非配送日
    requestOrderDeliver() {
      OrderDeliver()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              if (response.data.ladysHolidayFlg) {
                this.deliverVisible = true;
              } else {
                this.deliverVisible = false;
              }
              this.deliverMessage = response.data.forecastDeliverTime;
            }
          });
    },

    requestGoodsList() {
      GoodsList(-1, LIMIT, this.type)
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              this.goodsList = [];
              response.data.list.forEach((item) => {
                this.goodsList.push({
                  id: item.id,
                  name: item.name,
                  price: numFilter(item.price),
                  spec: item.spec,
                  imageUrl: BASE_URL + item.imageUrl,
                  goodsNumber: item.goodsNumber,
                  ykNumber: 0,
                  isPresellTip: item.id === this.$GOODS.YAKULT_TWENTY_GRAPE_ID
                })
              })

              let selectedGoods = localStorage.getItem("selectedGoods")
              if (selectedGoods !== null && selectedGoods !== "") {
                let goods = JSON.parse(selectedGoods)
                this.goodsList.forEach((item, index) => {
                  this.goodsList[index].ykNumber = goods[index].ykNumber
                })
              }
            }
            // 计算总价和总支数
            let sum = 0;
            let totalCount = 0;
            this.goodsList.forEach(element => {
              sum += parseFloat(element.ykNumber) * parseFloat(element.price);
              totalCount += parseInt(element.ykNumber) * parseInt(element.goodsNumber);
            });
            this.ykTotalPrice = sum.toFixed(2)
            this.totalCount = totalCount
          });
    },

    ykReduce(item, index) {
      if (this.isDisabled(item)) return;
      let ykNumber = item.ykNumber
      if (ykNumber > 0) {
        this.goodsList[index].ykNumber = ykNumber - 1
        if (this.goodsList[index].ykNumber === 0 && item.id === this.$GOODS.YAKULT_TWENTY_GRAPE_ID) {
          this.isQingti20Selected = false
        }
        // 重新计算总价
        let noChoose = true;

        let sum = 0;
        let totalCount = 0;
        this.goodsList.forEach(element => {
          sum += parseFloat(element.ykNumber) * parseFloat(element.price);
          totalCount += parseInt(element.ykNumber) * parseInt(element.goodsNumber);
        });
        this.ykTotalPrice = sum.toFixed(2)
        this.totalCount = totalCount
        if (noChoose) {
          this.buttonStatus = 0;
        }
        this.ykTotalPrice = sum.toFixed(2)
      }
    },

    ykAdd(item, index) {
      if (this.isDisabled(item)) return;
      let ykNumber = item.ykNumber;
      let numTotal = this.stampMaxNum;
      if (ykNumber < numTotal) {
          // 禁用“益力多青提味20瓶”的添加功能，并将其数量置为0
          let updatedGoodsList = this.goodsList.map((goodsItem) => {
              goodsItem.isPresellTip = false;
              return goodsItem;
          });
          this.goodsList[index].ykNumber = item.ykNumber + 1
          this.goodsList = updatedGoodsList;
          if (this.grapePresale && item.id === this.$GOODS.YAKULT_TEN_DT_ID) {
            this.buttonStatus = 3;
          } else {
            this.buttonStatus = 1;
          }
      }
      // 重新计算总价
      let sum = 0;
      let totalCount = 0;
      this.goodsList.forEach(element => {
        sum += parseFloat(element.ykNumber) * parseFloat(element.price);
        totalCount += parseInt(element.ykNumber) * parseInt(element.goodsNumber);
      });
      this.ykTotalPrice = sum.toFixed(2)
      this.totalCount = totalCount
    },

    modifyAddress() {
      let addId = localStorage.getItem('addressId');
      if (addId !== null && addId !== '') {
        localStorage.setItem('addressId', this.addressId);
      }

      // 保存选购商品的数量信息
      let selectedGoods = []
      this.goodsList.forEach(item => {
        selectedGoods.push({id: item.id, ykNumber: item.ykNumber})
      })
      localStorage.setItem("selectedGoods", JSON.stringify(selectedGoods))
      localStorage.setItem("ykTotalPrice", this.ykTotalPrice)
      localStorage.setItem("remark", this.remark);

      this.$router.push({path: '/addressChoose', query: {}})
    },

    // 点击提交订单提示
    async orderTip() {
      var num = 0;
      this.goodsList.forEach(item => {
        num += item.ykNumber
      })
      if (num <= 0) {
        this.toast('请添加要购买的数量');
        return;
      }
      if (this.addAddress) {
        this.toast('请添加收货地址');
        return;
      }
      if (this.goodsList.length <= 0) {
        // this.toast('请添加要购买的数量');
        return;
      }
      // let numTotal = this.stampMaxNum;
      // if (num > numTotal ) {
      //     this.toast('商品订购数量不能大于'+numTotal+'排');
      //     return;
      // }
      if (this.code) {
        const isValid = await this.checkStamp(this.code);
        if (isValid) {
          this.checkStampCode = false;
        } else {
          this.checkStampCode = true;
        }
      }
      this.ykTotalNumber = num
      CheckActivityOrderSubmit().then((response) => {
        if (response.code === this.$API_CODE.OK) {
          this.canParticipate = response.data.canParticipate
          this.needPurchaseQuantity = response.data.needPurchaseQuantity
        }
        this.orderVisible = true;
      })
    },

    // 校验兑换码
    checkStamp(code) {
      return new Promise((resolve, reject) => {
        checkStamp(code)
            .then((response) => {
              if (response.code === this.$API_CODE.OK) {
                resolve(true);  // 活动码有效
              } else {
                resolve(false); // 活动码无效
              }
            })
            .catch((error) => {
              console.error('Error checking stamp code:', error);
              reject(false);
            });
      });
    },

    submitOrder() {
      let goodsId = [];
      let numbers = [];
      let unitprices = [];
      this.goodsList.forEach(item => {
        goodsId.push(item.id)
        numbers.push(item.ykNumber)
        unitprices.push(Number(item.ykNumber * item.price).toFixed(2))
      })

      let num = this.ykTotalNumber;
      let numTotal = this.stampMaxNum;
      if (num > numTotal) {
        this.toast('商品订购数量不能大于' + numTotal + '排');
        return;
      }
      if (num <= 0) {
        this.btnDisable = false;
        this.toast('请添加要购买的数量');
        return;
      }
      this.btnDisable = true;

      // 将选中的兑换券数据转换为JSON字符串
      const selectedVoucherListStr = JSON.stringify(this.selectedStamps);

      OrderSubmit(goodsId.join(','), numbers.join(','), unitprices.join(','), this.remark, this.addressId, false, 0, this.code, selectedVoucherListStr)
        .then((response) => {
          if (response.code === this.$API_CODE.OK) {
            this.messageVisible = false;
            let orderId = response.data.orderId;
            let orderNumber = response.data.orderNumber;
            let orderData = response.data.forecastDeliverTime;
            let freed = false;
            this.$router.push({path: '/orderSuccess', query: {orderId, orderNumber, orderData, freed}});
            // 清空一些本地数据
            localStorage.setItem('selectedGoods', "")
            localStorage.setItem('ykTotalPrice', "")
          } else {
            this.messageVisible = true;
            this.message = response.message;
          }
          this.btnDisable = false;
        });
      this.orderVisible = false;
    },

    requestMemberDefaultAddress() {
      AddressDefault()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              if (response.data) {
                this.addressId = response.data.id;
                this.username = response.data.consignee;
                this.tel = starPhone(response.data.mobile);
                this.address = response.data.area + response.data.address;
              } else {
                this.addAddress = true;
              }

            }
          })
    },

    requestStampMaxNum() {
      getStampMaxNum()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              this.stampMaxNum = response.data.maxStampNum;
            }

          })

    },
    requestPresaleStatus() {
      CheckPresale()
          .then((response) => {
            if (response.code === this.$API_CODE.OK) {
              this.grapePresale = response.data.isPresaleDto;
            }
          })
    }
  },


}
</script>

<style scoped lang="scss">
#place-order {
  /*margin-bottom: 6rem;*/
  #place-order-header {
    padding: 20px 30px;
    background: url("../../assets/address.png") no-repeat;
    background-size: 100% auto;
    /*height: 8rem;*/
    width: 100%;

    .place-header-detail {
      background: #faf2ed;
      /*margin-top: 15px;*/
      border-radius: 5px;
      padding: 15px 10px 15px 10px;
      text-align: center;

      .add-address {
        background: #ea2d53;
        padding: 8px 12px;
        border-radius: 5px;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 1rem;
        margin-top: -8px;
        float: right;
      }

      .detail-info {
        //float: left;

        .username {
          text-align: left;
          font-size: 0.8rem;
        }

        .address {
          text-align: left;
          font-size: 0.7rem;
          margin-top: 5px;
          color: #ea2d53;
          float: left;
          width: 80%;
        }
      }

      .icon {
        margin-left: 10px;
        margin-top: 15px;
        float: right;
      }
    }
  }

  #place-order-body {
    position: relative;
    width: 100%;
    margin-top: 40px;

    .place-order-line {
      height: 87%;
      width: 3px;
      background: #ea2d53;
      margin-left: 70px;
      position: absolute;
      margin-top: -40px;
      z-index: -1;
    }

    .place-order-body-yk {
      width: 100%;
      height: 185px;
      margin-top: 4%;
      z-index: 1;

      .place-yk-img {
        width: 100px;
        height: 100px;
        float: left;
        margin-top: 30px;
        margin-right: 20px;
        margin-left: 20px;
      }

      .place-yk-explain {
        text-align: left;
        margin-left: 155px;

        .title {
          color: #ea2d53;
          font-weight: bold;
          font-size: 1.1rem;
        }

        .rule {
          margin-top: 15px;
        }

        .price {
          margin-top: 15px;
        }


        .explain-number {
          margin-top: 20px;

          .add {
            float: left;
            width: 40px;
            height: 33px;
            line-height: 33px;
            border: 1px solid #ea2d53;
            text-align: center;
            color: #ea2d53;
            font-size: 1.5rem;

            &.disabled {
              background-color: #f5f5f5;
              color: #cccccc;
              border-color: #cccccc;
            }
          }

          .number {
            width: 40px;
            height: 33px;
            float: left;
            border: 1px solid #ea2d53;
            line-height: 33px;
            text-align: center;
            font-weight: bold;

            &.disabled {
              background-color: #f5f5f5;
              color: #cccccc;
              border-color: #cccccc;
            }
          }

          .is-presell-tip-disabled {
            border: 1px solid #B2B2B2;
            color: #B2B2B2;
          }
        }

        .tip {
          padding-top: 10px !important;
          clear: both;
          color: #ea2d53;
          font-size: 1rem;
          font-weight: normal !important;
        }
      }
    }
  }

  .place-yk-remark1 {
    height: 80px;
    margin: 20px;
    border: 3px solid #ea2d53;
    background: #faf2ed;
    border-radius: 5px;
  }

  .place-yk-remark1 .clickable-line {
    border: none;
    border-bottom: 1px solid #ea2d53;
    margin: 5px 20px;
    width: 80%;
    height: 30px;
    background-color: transparent;
    text-align: center;
    font-size: 16px;
    color: #000;
  }

  /* 特定输入框的 placeholder 样式 */
  .custom-placeholder::-webkit-input-placeholder,
  .custom-placeholder:-moz-placeholder,
  .custom-placeholder::-moz-placeholder,
  .custom-placeholder:-ms-input-placeholder,
  .custom-placeholder::placeholder {
    color: #B2B2B2;
    font-size: 14px;
  }

  .place-yk-remark1 .place-remark-input1 {
    line-height: 30px;
    font-weight: bold;
    text-align: center;
    letter-spacing: 2px;
    color: white;
    height: 30px;
    outline: 3px solid #ea2d53;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background: #ea2d53;
    font-size: 0.9rem;
    width: 100%;
  }

  .place-yk-remark {
    margin: 20px;

    .place-remark-input {
      width: 100%;
      height: 80px;
      padding: 10px;
      border: 3px solid #ea2d53;
      border-radius: 5px;
      background: #faf2ed;
      font-size: 0.9rem;
    }
  }

  .place-order-box {
    height: 6rem;
  }

  #place-order-footer {
    right: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 1;
    background: #ffffff;

    .place-footer-price {
      color: #757575;
      width: 62%;
      float: left;
      padding-top: .4rem;
      padding-bottom: .4rem;;
      font-size: 0.9rem;
      border-top: 1px solid #dddddd;

      div {
        margin-top: 5px;
      }

      .price-number {
        color: #ea2d53;
        font-size: 1.3rem;
        /*font-weight: bold;*/
        margin-top: 20px
      }
    }

    .place-submit-order {
      width: 38%;
      height: 4rem;
      line-height: 4rem;
      float: left;
      font-size: 1.1rem;
      font-weight: bold;
      background: #ea2d53;
      color: #FFFFFF;
    }
  }

  .tip {
    color: #ea2d53;
    font-size: 1rem;
    font-weight: bold;
  }

  .message {
    text-align: center;
    padding: 10px;
  }

  .tip-stamp {
    float: left;
    width: 40%;
    color: #ffffff;
    padding: 10px 0;
    background: #ea2d53;
    border-radius: 5px;
    font-size: 0.95rem;
    white-space: nowrap;
    border: none;

    &:disabled {
      background: #595959;
    }
  }

  .tip-cancel {
    float: left;
    width: 25%;
    color: #ffffff;
    padding: 10px 0;
    background: #ea2d53;
    border-radius: 5px;
    margin-left: 5%;
    border: none;
  }

  .tip-ok {
    width: 25%;
    float: right;
    color: #ffffff;
    padding: 10px 0;
    background: #ea2d53;
    border-radius: 5px;
    border: none;
  }

  /* 兑换卷列表样式 */
  .stamp-list {
    padding: 15px 10px;
    max-height: 350px;
    overflow-y: auto;
  }

  .stamp-item {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #f0f0f0;
    padding: 0;
  }

  .stamp-item:last-child {
    border-bottom: none;
  }

  /* 父选项样式 */
  .stamp-parent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 10px;
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
  }

  .stamp-parent.has-child {
    background: #fafafa;
    border-radius: 5px;
    margin-bottom: 5px;
  }

  /* 展开/收起箭头图标 */
  .expand-icon {
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .arrow {
    font-size: 12px;
    color: #999;
    transition: transform 0.3s ease;
    transform: rotate(-90deg);
    display: inline-block;
  }

  .arrow.expanded {
    transform: rotate(0deg);
    color: #ea2d53;
  }

  .stamp-info {
    flex: 1;
    text-align: left;
    margin: 0 8px;
  }

  .stamp-name {
    font-size: 0.9rem;
    color: #333;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .stamp-time {
    font-size: 0.75rem;
    color: #999;
  }

  .stamp-hint {
    font-size: 0.75rem;
    color: #ea2d53;
    margin-top: 5px;
    font-weight: bold;
  }

  /* 子选项已选数量提示 */
  .child-hint {
    font-size: 0.7rem;
    color: #ea2d53;
    margin-right: 8px;
    white-space: nowrap;
  }

  .stamp-checkbox {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .checkbox-border {
    width: 20px;
    height: 20px;
    border: 2px solid #ea2d53;
    border-radius: 3px;
  }

  .checkbox-wrapper {
    width: 8px;
    height: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* 子选项列表样式 */
  .stamp-child-list {
    padding-left: 35px;
    padding-right: 10px;
    padding-bottom: 10px;
    width: 100%;
    box-sizing: border-box;
  }

  .stamp-child-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 12px;
    background: #fff5f7;
    border-radius: 5px;
    margin-bottom: 5px;
    cursor: pointer;
  }

  .stamp-child-item:last-child {
    margin-bottom: 0;
  }

  .child-info {
    flex: 1;
    text-align: left;
  }

  .child-name {
    font-size: 0.85rem;
    color: #666;
  }

  .child-checkbox {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .checkbox-border-small {
    width: 18px;
    height: 18px;
    border: 2px solid #ea2d53;
    border-radius: 50%;
  }

  .stamp-buttons {
    display: flex;
    justify-content: space-between;
    padding: 15px 10px 20px;
    gap: 15px;
  }

  .stamp-cancel-btn {
    flex: 1;
    background: #ea2d53;
    color: #ffffff;
    border-radius: 5px;
    font-size: 1rem;
    padding: 10px 0;
    border: none;
  }

  .stamp-confirm-btn {
    flex: 1;
    background: #ea2d53;
    color: #ffffff;
    border-radius: 5px;
    font-size: 1rem;
    padding: 10px 0;
    border: none;
  }
}
</style>
